import styled from 'styled-components';

export const PanelContent = styled.div`
  box-sizing: border-box;
  color: ${({ theme }) => theme.color.additional.dark.value};
  padding: 0 ${({ theme }) => `${theme.size.spacing.large.value} ${theme.size.spacing.large.value}`};
`;
